module.exports = __webpack_public_path__ + "static/media/undraw_a_whole_year_vnfm.83fa1cd4.svg";